"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { useTheme as v } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: c, size: h = 24 } = _param, i = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const o = n(), l = c !== null && c !== void 0 ? c : o ? a.colors.inverse : a.colors.neutralHigh, { skinName: r } = v();
    return r.match(/^blau/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M7.482 18.88h9.93v-8.511c0-.78-.639-1.419-1.42-1.419H8.902c-.78 0-1.419.639-1.419 1.419zm8.51-1.419H8.902v-7.092h7.092z"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M5 21.858h14.894V7.922c0-.567-.237-1.1-.61-1.49l-3.621-3.794A1.86 1.86 0 0 0 14.24 2H7.03C5.914 2 5 2.957 5 4.128zm13.54-1.418H6.354V4.128c0-.39.305-.71.677-.71h7.21q.304 0 .508.213l3.588 3.795c.135.141.203.319.203.496z"
            })
        ]
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M17.03 19.144H6.98v-8.572c0-.784.647-1.428 1.435-1.428h7.18c.787 0 1.434.644 1.434 1.428zm-8.615-1.428h7.18v-7.144h-7.18z"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M19.9 22H4.11V4.144C4.11 2.964 5.079 2 6.26 2h7.646c.575 0 1.114.216 1.507.644l3.84 3.82c.393.392.646.928.646 1.5zm-1.436-1.428V7.964a.7.7 0 0 0-.217-.5l-3.802-3.82a.73.73 0 0 0-.539-.216H6.261a.72.72 0 0 0-.72.716v16.428z"
            })
        ]
    })) : r.match(/^o2/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M17.03 19.144H6.98v-8.572c0-.784.647-1.428 1.435-1.428h7.18c.787 0 1.434.644 1.434 1.428zm-8.615-1.428h7.18v-7.144h-7.18z"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M19.9 22H4.11V4.144C4.11 2.964 5.079 2 6.26 2h7.646c.575 0 1.114.216 1.507.644l3.84 3.82c.393.392.646.928.646 1.5zm-1.436-1.428V7.964a.7.7 0 0 0-.217-.5l-3.802-3.82a.73.73 0 0 0-.539-.216H6.261a.72.72 0 0 0-.72.716v16.428z"
            })
        ]
    })) : /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M7.901 19.387a.56.56 0 0 1-.56-.56v-8.611c0-.308.252-.56.56-.56h8.194c.308 0 .56.252.56.56v8.61a.56.56 0 0 1-.56.56zm.56-3.852h7.073v-2.028H8.462zm1.606 1.12H8.462v1.611h1.605zm1.12 1.611h1.61v-1.61h-1.61zm2.731 0h1.616v-1.61h-1.616zm-3.851-5.88v-1.61H8.462v1.61zm2.73 0v-1.61h-1.61v1.61zm2.737 0v-1.61h-1.616v1.61z"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M16.638 21.835H7.361c-.482 0-1.16-.106-1.647-.622-.362-.384-.552-.927-.552-1.577V6.264a.56.56 0 0 1 .18-.412l3.82-3.544a.57.57 0 0 1 .38-.148h7.096c.482 0 1.16.106 1.647.622.361.384.552.927.552 1.577v15.277c0 .65-.19 1.194-.552 1.577-.269.283-.773.622-1.647.622M6.282 6.507v13.13c0 .744.334 1.078 1.079 1.078h9.277c.745 0 1.078-.334 1.078-1.079V4.36c0-.745-.333-1.079-1.078-1.079H9.764z"
            })
        ]
    }));
}, H = m;
export { H as default };
